import store from '../apps/store/store'
import { setCart, setCartOpen, setUpsells } from '../apps/store/cartSlice'
import { getXgenProducts } from './Product.js'

export const getCart = (callback = null, open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json();
  })
  .then(cart => {
    console.log(cart)
    store.dispatch(setCart(cart))
    store.dispatch(setCartOpen(open))
    updateUpsells()
    if(buttonElement) buttonElement.disabled = false
    if(callback) callback(cart)
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

export const addLineItems = (callback = null, items = [], open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  })
  .then(response => {
    return response.json();
  })
  .then(response => {
    console.log(response)
    getCart(callback, open, buttonElement)
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}
window.addLineItems = addLineItems

export const changeLineItem = (callback = null, item = {}, open = true) => {
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
  .then(response => {
    return response.json();
  })
  .then(cart => {
    console.log(cart)
    store.dispatch(setCart(cart))
    store.dispatch(setCartOpen(open))
    updateUpsells()
    if(callback) callback(cart)
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

export const updateUpsells = () => {
  const cartDrawerWrapper = document.querySelector('[data-cart-drawer]')
  const cartProps = JSON.parse(cartDrawerWrapper.getAttribute('props'))
  if(cartProps.xgenId) {
    const excludeSale = cartProps.excludeSale == true || cartProps.excludeSale == 'true'
    if(typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(cartProps.xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        getXgenProducts((results) => {
          console.log(results)
          const filteredResults = excludeSale ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
          store.dispatch(setUpsells(filteredResults))
          setTimeout(() => {
            window.setupProductTiles(cartDrawerWrapper.querySelectorAll('[product-tile]:empty'))
            if(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]')) {
              if(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]').swiper) cartDrawerWrapper.querySelector('[data-inline-cart-swiper]').swiper.destroy(true, true)
              new Swiper(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]'), {
                speed: 500,
                loop: true,
                spaceBetween: 16,
                slidesPerView: 2,
                breakpoints: {
                  320: {
                    slidesPerView: 2.7
                  },
                  1024: {
                    slidesPerView: 2
                  }
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }
              })
            }
          }, 300)
        }, skus)
      })
    }
  }
}